import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { ConfigService } from "../config/config.service";
import { EventsService } from "../event/event.service";
import { UniqueIDService } from "../unique-id/unique-id.service";
import { App } from "@capacitor/app";
import { AppIcon } from '@capacitor-community/app-icon';
import { JurisdictionService } from "../geo/jurisdiction.service";

@Injectable({
  providedIn: "root",
})

export class MobileToolsService {
  public insets: any;
  public shouldSelectEnvironment: boolean = false;
  public shouldUpdate: boolean = false;
  public shouldRestrictPlayStore: boolean = false;

  constructor(
    private config: ConfigService,
    private eventsService: EventsService,
    private geoJurisdictionService: JurisdictionService,
    private http: HttpClient,
    private navigator: Navigator,
    private platform: Platform,
    private uniqueIDProvider: UniqueIDService,
  ) { }

  async checkEnvironmentSelector() {
    if (this.platform.is("capacitor")) {
      let deviceId = await this.uniqueIDProvider.getSelectorID();
      try {
        let optionParams = new HttpParams();
        optionParams.set("device_id", deviceId);
        console.log("check_device device_id:", deviceId);

        const checkdevice_url = `https://devpala1.palainteractive.com/check_device.php?device_id=${deviceId}&ts=${Date.now()}`;
        console.log(`check_device call: ${checkdevice_url}`);

        const data: any = await this.http.get(checkdevice_url).toPromise()
        console.log("check_device response:", JSON.stringify(data));

        let response = data;
        if (response.result == 1) {
          console.log("DEBUG MODE ALLOWED");
          this.shouldSelectEnvironment = true;
        } else {
          // v this.eventsService.publish("event:affiliation:initialize");
          this.eventsService.publish("event:config:final"); // this event fires *after* environment-selector phase is done
        }

      }
      catch (err) {
        console.log("...something wrong when checking device id: ", err);
        // v this.eventsService.publish("event:affiliation:initialize");
        this.eventsService.publish("event:config:final"); // this event fires *after* environment-selector phase is done -- very useful!
      };
    } else {

      console.log("UpdateCheckComplete")
      // v  this.eventsService.publish("event:affiliation:initialize");
      setTimeout(() => {
        this.eventsService.publish("event:config:final"); // this event fires *after* environment-selector phase is done 
      }, 1000);
    }
  }

  async checkRestrictedPlayStore() {
    if (this.platform.is("android")) {
      this.http.get(this.config.getEnv().webservices_url + '/configuration/get-is-allowed', {}).subscribe((response: any) => {
        if ((!response.payload || !(response.payload.geo.eligib === 'true')) && !this.shouldSelectEnvironment) {
          this.shouldRestrictPlayStore = true;
          this.navigator.navigateTo("AppRestrictedComponent", {}, {});
        }
      });
    }
  }

  async checkForUpdate() {
    console.log("MobileToolsService checkForUpdate")

    console.log(`MobileToolsService APP_UPDATE_VERSION_ANDROID      ${this.config.getConfig().APP_UPDATE_VERSION_ANDROID}`)
    // console.log(`MobileToolsService APP_UPDATE_MESSAGE_ANDROID      ${this.config.getConfig().APP_UPDATE_MESSAGE_ANDROID}`)
    // console.log(`MobileToolsService APP_UPDATE_BUTTON_LABEL_ANDROID ${this.config.getConfig().APP_UPDATE_BUTTON_LABEL_ANDROID}`)
    // console.log(`MobileToolsService APP_UPDATE_URL_ANDROID          ${this.config.getConfig().APP_UPDATE_URL_ANDROID}`)

    console.log(`MobileToolsService APP_UPDATE_VERSION_IOS          ${this.config.getConfig().APP_UPDATE_VERSION_IOS}`)
    // console.log(`MobileToolsService APP_UPDATE_MESSAGE_IOS          ${this.config.getConfig().APP_UPDATE_MESSAGE_IOS}`)
    // console.log(`MobileToolsService APP_UPDATE_BUTTON_LABEL_IOS     ${this.config.getConfig().APP_UPDATE_BUTTON_LABEL_IOS}`)
    // console.log(`MobileToolsService APP_UPDATE_URL_IOS              ${this.config.getConfig().APP_UPDATE_URL_IOS}`)

    const androidInfo = {
      version: this.config.getConfig().APP_UPDATE_VERSION_ANDROID || null,
      url: this.config.getConfig().APP_UPDATE_URL_ANDROID || null,
      message: this.config.getConfig().APP_UPDATE_MESSAGE_ANDROID || null,
      buttonLabel: this.config.getConfig().APP_UPDATE_BUTTON_LABEL_ANDROID || null,
    };

    const iosInfo = {
      version: this.config.getConfig().APP_UPDATE_VERSION_IOS || null,
      url: this.config.getConfig().APP_UPDATE_URL_IOS || null,
      message: this.config.getConfig().APP_UPDATE_MESSAGE_IOS || null,
      buttonLabel: this.config.getConfig().APP_UPDATE_BUTTON_LABEL_IOS || null,
    };

    const info = this.platform.is("capacitor") ? await App.getInfo() : { "id": "com.mohegansun.casinoapp", "version": "1.0.99", "build": "1", "name": "Mohegan Sun Casino" }
    console.log(`MobileToolsService App.getInfo() ${JSON.stringify(info)}`, info)

    const v: string = !!info.version ? info.version : "1.0.0";

    let version, url, message, btnLabel;
    if (iosInfo.version != null && androidInfo.version != null)
      version = this.platform.is("ios") ? iosInfo.version : androidInfo.version;
    else {
      // version = data.version;
    }

    if (androidInfo.url != null && iosInfo.url != null) {
      url = this.platform.is("ios") ? iosInfo.url : androidInfo.url;
    }
    if (androidInfo.message != null && iosInfo.message != null) {
      message = this.platform.is("ios") ? iosInfo.message : androidInfo.message;
    }
    if (androidInfo.buttonLabel != null && iosInfo.buttonLabel != null) {
      btnLabel = this.platform.is("ios") ? iosInfo.buttonLabel : androidInfo.buttonLabel;
    }

    let currentParts = v.split(".");
    let checkingParts = version.split(".");

    if (parseInt(currentParts[0]) < parseInt(checkingParts[0])) {
      console.log("new MAJOR version");
      this.shouldUpdate = true;
    } else if (
      parseInt(currentParts[0]) == parseInt(checkingParts[0]) &&
      parseInt(currentParts[1]) < parseInt(checkingParts[1])
    ) {
      console.log("new MINOR version");
      this.shouldUpdate = true;
    } else if (
      parseInt(currentParts[0]) == parseInt(checkingParts[0]) &&
      parseInt(currentParts[1]) == parseInt(checkingParts[1]) &&
      parseInt(currentParts[2]) < parseInt(checkingParts[2])
    ) {
      console.log("new BUILD version");
      this.shouldUpdate = true;
    }

    if (!this.shouldUpdate) {
      console.log("UP TO DATE!");
    } else {
      console.log("NEEDS UPDATE!");

      this.navigator.navigateTo("AppUpdateComponent", {}, {
        appversion: version,
        appURL: url,
        appMessage: message,
        btnLabel: btnLabel,
      });
    }
  }

  public async setIOSAppIcon(): Promise<void> {
    try {
      const isSupported = await AppIcon.isSupported();
      if (!isSupported) return;

      const currentIconName = await AppIcon.getName();
      const config = this.config.getConfig();
      const featureIOSAppICon = config.FEATURE_CHANGE_IOS_APPICON ?? null;
      const altIconName = "AppIcon1";
      if (featureIOSAppICon) {
        const variant = featureIOSAppICon === "1" ? 'A' : 'B';
        if (variant === "A" && currentIconName.value !== altIconName) {
          this.changeAppIcon(altIconName);
        } else if (variant === "B" && currentIconName.value) {
          this.resetAppIcon();
        }
      } else if (currentIconName.value) {
        this.resetAppIcon();
      }
    } catch (error) {
      console.error("Error setting iOS app icon:", error);
    }
  }

  protected async changeAppIcon(altIconName) {
    await AppIcon.change({ name: altIconName, suppressNotification: true })
  }

  protected async resetAppIcon() {
    await AppIcon.reset({ suppressNotification: true })
  }

  public requestAndroidGeoPermissions() {
    if (this.geoJurisdictionService.shouldDisplayPermissionReason()) {
      this.geoJurisdictionService
        .displayPermissionReason()
        .then((acceptsReason: any) => {
          console.log("displayPermissionReason ", acceptsReason)
          this.geoJurisdictionService._didUserAcceptReason = acceptsReason;
          //first dialog allow
          if (acceptsReason && "data" in acceptsReason && acceptsReason.data) {
            console.log("Requesting native permissions")
            this.geoJurisdictionService.requestNativePermissionsDialog(
              () => {
                /*all good, continue*/
                this.geoJurisdictionService.setAcceptReason(true);
              },
              (deny) => {
                console.log("Android geo ", deny);

                return this.navigator.navigateTo("AppRestrictedComponent", {
                  customModalClass: "app-restricted-screen",
                  animated: false,
                });

              }
            );

          } else {
            // first dialog cancel
            return this.navigator.navigateTo("AppRestrictedComponent", {
              customModalClass: "app-restricted-screen",
              animated: false,
            });
          }
        });
    }
  }
}
